import { render, staticRenderFns } from "./ModalFranchiseEdit.vue?vue&type=template&id=28d37ee3&scoped=true&"
import script from "./ModalFranchiseEdit.vue?vue&type=script&lang=js&"
export * from "./ModalFranchiseEdit.vue?vue&type=script&lang=js&"
import style0 from "./ModalFranchiseEdit.vue?vue&type=style&index=0&id=28d37ee3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d37ee3",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VButton: require('/home/circleci/repo/components/VButton.vue').default})
